<template>
  <div class="d-flex inter-font" id="wrapper">
    <sidebar />
    <div id="page-content-wrapper">
      <navbar :custom-breadcrumb="customBreadcrumb" />
      <div class="container-fluid mt-4">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { Sidebar, Navbar } from "./Navigation";
export default {
  name: "Wrapper",
  props: {
    customBreadcrumb: {
      type: Array,
      default: () => [],
    },
  },
  components: { Sidebar, Navbar },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.inter-font {
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/Wrapper.vue